import TUISearch from './index.vue';
export default TUISearch;